<template>
  <c-dialog
    :value="value"
    width="600"
    close-key="cove.general.cancel"
    title-key="popup.filingReceiptPreview.title"
    @input="close">

    <div class="pa-4">
      <div class="c-caption">
        {{ $t('global.details') }}
      </div>
      <div class="text-minimum-gray">
        {{ $t('popup.filingReceiptPreview.details.description') }}
      </div>

      <section-separator :title="$t('global.orderSummary')" class="mt-6 mb-2"/>
      <receipt-order-line-items :receipt="receiptPreviewDTO"/>
    </div>

    <template #actions-right>
      <template v-if="hasValidPaymentProcessorButtonImage">
        <v-btn class="px-0 elevation-1 rounded" @click="checkout">
          <img :src="paymentProcessorButtonImageLink" style="height:36px;border-radius:4px;" alt=""/>
          <span class="d-sr-only">
            {{ $t('global.checkout') }}
          </span>
        </v-btn>
      </template>
      <template v-else>
        <c-btn type="primary" class="px-4" @click="checkout">
          {{ $t('global.checkout') }}
        </c-btn>
      </template>
    </template>
  </c-dialog>
</template>

<script>
import _ from 'lodash';
import SectionSeparator from '@components/support/SectionSeparator';
import ReceiptOrderLineItems from '@components/support/accounting/ReceiptOrderLineItems';
import { useApplicationStore } from '@/stores/applicationStore';

const applicationStore = useApplicationStore();

export default {
  components: { SectionSeparator, ReceiptOrderLineItems },
  props: {
    value: {
      type: Boolean
    },
    receiptPreviewDTO: {
      type: Object
    }
  },
  computed: {
    hasValidPaymentProcessorButtonImage () {
      return !_.isNil(this.paymentProcessorButtonImageLink);
    },
    paymentProcessorButtonImageLink () {
      let paymentClientName = applicationStore.getAppProperty(this.CONST.APP_PROPERTY_PAYMENT_CLIENT);
      try
      {
        return require('@/assets/paymentClient/' + paymentClientName + '/checkout.png');
      }
      catch (e)
      {
        // Catch and eat exception if the image can't be found; A fallback button will be displayed instead
        return null;
      }
    }
  },
  methods: {
    checkout () {
      this.$emit('checkout');
      this.close();
    },
    close () {
      this.$emit('input', false);
    }
  }
};
</script>